import { render, staticRenderFns } from "./StartupProfileModal.vue?vue&type=template&id=0a2b6932&scoped=true&"
import script from "./StartupProfileModal.vue?vue&type=script&lang=js&"
export * from "./StartupProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./StartupProfileModal.vue?vue&type=style&index=0&id=0a2b6932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b6932",
  null
  
)

export default component.exports